/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

export const planDataTier = {
	lite: 'lite',
	standard: 'standard',
	pro: 'pro',
	premium: 'premium',
	enterprise: 'enterprise',
	service: 'service',
} as const

export type PlanDataTier = (typeof planDataTier)[keyof typeof planDataTier]
